import {
  Brand,
  BrandFamily,
  Countries,
  Domains,
  FlowType,
  Languages,
  LegalArea,
  Locales,
  TranslationTenant,
} from "@/core/types/types";
import {
  getBrandName,
  getCountryByDomain,
  getFlowTypeFromLegalArea,
  getLanguageByDomain,
  getLegalAreaFromRequest,
  getTopLevelDomain,
} from "@/core/utils/";
import getBrandConfiguration, { getDomainData } from "./getBrandConfiguration";
import { InitialisationConfig } from "./getInitialisationConfig";
import { IncomingHttpHeaders } from "http";
import { ParsedUrlQuery } from "querystring";

interface BasicConfigRequestInput {
  host?: string;
  headers?: IncomingHttpHeaders;
  path?: string;
  query?: ParsedUrlQuery | undefined;
}

const getBasicConfig = (
  input: BasicConfigRequestInput
): InitialisationConfig => {
  const { host = "", path = "", headers = {}, query = {} } = input;

  const domain: Domains = getTopLevelDomain(host) as Domains;
  const brandName: Brand = getBrandName(host);
  const language: Languages = getLanguageByDomain(domain);
  const country: Countries = getCountryByDomain(domain);
  const locale: Locales = `${language}_${country}` as Locales;
  const brandConfiguration = getBrandConfiguration(brandName);
  const legalArea: LegalArea = getLegalAreaFromRequest(
    path,
    headers,
    query.definitionName
  );
  const definitionName: FlowType = getFlowTypeFromLegalArea(
    legalArea,
    brandConfiguration.brandFamily ?? BrandFamily.DEFAULT,
    domain
  );
  const translationTenant: TranslationTenant =
    brandConfiguration.legalAreas[legalArea]?.translationTenant ??
    TranslationTenant.DEFAULT;
  const brandId = Object.values(Brand).includes(brandName)
    ? brandName
    : Brand.DEFAULT;

  const fullRequestPageUrl = `https://${host}${path}`;

  return {
    domain,
    language: getDomainData(brandId, legalArea, domain)?.language ?? language,
    locale: locale,
    definitionName,
    brandFamily: brandConfiguration.brandFamily ?? BrandFamily.DEFAULT,
    brandId,
    legalArea,
    translationTenant,
    fullRequestPageUrl,
  };
};

export default getBasicConfig;
